<template>
  <main>
    <header id="header">
      <p class="title-sub title-font">おうちで楽しめる！</p>
      <h1 class="title title-font">
        リトル・ママ<br>オンライン<br>フェスタ
      </h1>
    </header>
    <!-- <div class="main-visual">
    </div> -->

    <online-festa-schedules festas=""></online-festa-schedules>

    <BannerAd />

    <section class="step-area">
      <h2>オンラインフェスタの楽しみ方は<br class="tablet-only">ここ↓をチェックしよう♪</h2>
      <div class="step-detail">
        <div class="container">
          <div class="row">
            <h3>チケットを取得しよう！</h3>
            <figure>
              <img class="imgstep" src="/img/about/step_img01.png" alt="まずはインスタフォロー">
            </figure>
            <p class="text-center step-txt">チケットを取得して最新情報をGETしよう！取得は<a href="https://l-ma.info/2TioczM" target="_blank">こちら</a></p>
          </div>
          <div class="row">
            <h3>当日の楽しみ方はこちら</h3>
            <div class="box wow">
              <div class="inner img step01 wow">
                <figure>
                  <img src="/img/about/step_img02.jpg" alt="STEP01 10:00~みんなインスタライブに集まれ">
                </figure>
              </div>
              <div class="inner txt">
                <h4>みんなインスタライブに集まれ</h4>
                <p>オープニングはこちらから！イベントの楽しみ方やおすすめのLIVE配信などを紹介します。</p>
              </div>
            </div>
            <div class="box reverse wow">
              <div class="inner img step02 wow">
                <figure>
                  <img src="/img/about/step_img03.jpg" alt="STEP02 10:30~15:20 LIVE中に抽選会キーワードGET">
                </figure>
              </div>
              <div class="inner txt">
                <h4>LIVE中に抽選会キーワードGET</h4>
                <p>1日中開催されている「プレゼントキーワード付き企業LIVE」に自由に参加して、キーワードを集めよう★</p>
              </div>
            </div>
            <div class="box wow">
              <div class="inner img step03 wow">
                <figure>
                  <img src="/img/about/step_img04.jpg" alt="STEP03 10:30~15:20 「ママ主催者LIVE」に参加しよう">
                </figure>
              </div>
              <div class="inner txt">
                <h4>「学び・体験・遊びLIVE」に参加しよう</h4>
                <p>全国のママ主催者が楽しいイベントを開催！<br>たくさんの楽しい体験と出会おう♪参加はすべて無料！</p>
              </div>
            </div>
            <div class="box reverse wow">
              <div class="inner img step04 wow">
                <figure>
                  <img src="/img/about/step_img05.jpg" alt="STEP04 10:30~15:40 抽選会にエントリーしよう">
                </figure>
              </div>
              <div class="inner txt">
                <h4>抽選会にエントリーしよう</h4>
                <p>「プレゼントキーワード付き企業LIVE」でゲットしたキーワードを3つ集めて参加しよう。<br>豪華賞品が当たるチャンス♪当選者は当日発表しますよ！</p>
              </div>
            </div>
            <div class="box wow">
              <div class="inner img step05 wow">
                <figure>
                  <img src="/img/about/step_img06.jpg" alt="STEP05 15:50～16:10 全員集合！抽選会の当選者発表">
                </figure>
              </div>
              <div class="inner txt">
                <h4>全員集合！抽選会の当選者発表</h4>
                <p>インスタライブで抽選会当選者を発表！どのLIVEがおもしろかったか皆でシェアする時間もあるよ♪</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="award-area">
      <div class="container">
        <h2>当日は豪華賞品が当たる<br class="sp-only">抽選会を実施</h2>
        <div class="row">
          <div class="box wow">
            <div class="inner img">
              <figure>
                <img src="/img/about/comingsoon1.jpg" alt="リトル・ママ会員なら誰でも参加できるよ">
              </figure>
            </div>
            <div class="inner txt">
              <p>リトル・ママ会員<br>なら誰でも参加<br>できるよ</p>
            </div>
          </div>
          <div class="box reverse wow">
            <div class="inner img">
              <figure>
                <img src="/img/about/comingsoon2.jpg" alt="抽選会エントリーフォームは当日にイベントHPで公開">
              </figure>
            </div>
            <div class="inner txt">
              <p>抽選会<br>エントリーフォームは<br>チケットを取得してGET</p>
            </div>
          </div>
          <div class="box-wide">
            <figure>
              <img src="/img/about/pc_comingsoon.jpg" alt="BALMUDA The Range" class="pc-only">
              <img src="/img/about/sp_comingsoon.jpg" alt="BALMUDA The Range" class="sp-only">
            </figure>
          </div>
          <div class="box wow">
            <div class="inner img">
              <figure>
                <img src="/img/about/comingsoon4.jpg" alt="イベント当日抽選会キーワードを5つ集めて豪華賞品をGETしよう">
              </figure>
            </div>
            <div class="inner txt">
              <p>イベント当日<br>抽選会キーワードを<br>3つ集めて豪華賞品<br>をGETしよう</p>
            </div>
          </div>
          <div class="box reverse wow">
            <div class="inner img">
              <figure>
                <img src="/img/about/comingsoon5.jpg" alt="当選者はインスタライブで当日に発表">
              </figure>
            </div>
            <div class="inner txt">
              <p>当選者は<br>インスタライブで<br>当日に発表</p>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="btn"><a href="https://l-ma.info/2TioczM" target="_blank">チケットを取得して抽選会に備えよう</a></p>
          <p class="text-center">取得者には抽選会エントリーフォームを<br class="sp-only">メールで事前配布</p>
        </div>
      </div>
    </section>
    <section class="youtube-area">
      <div class="container">
        <div class="row">
          <!-- <div class="movie">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/k_p9OH43Hdc" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div> -->
          <p class="text-center">フェスタの楽しみ方をシェアしよう♪</p>
        </div>
      </div>
    </section>
    <section class="share">
      <div class="share-btn">
        <a href="https://social-plugins.line.me/lineit/share?url=https://festa.l-ma.co.jp/about/" target="_blank">
          <font-awesome-icon :icon="['fab', 'line']" />
        </a>
        <a href="https://twitter.com/intent/tweet?url=https://festa.l-ma.co.jp/about/&text=リトル・ママオンラインフェスタ" target="_blank">
          <font-awesome-icon :icon="['fab', 'twitter']" />
        </a>
        <a href="https://www.facebook.com/sharer/sharer.php?u=https://festa.l-ma.co.jp/about/" target="_blank">
          <font-awesome-icon :icon="['fab', 'facebook-f']" />
        </a>
        <button type="button" id="copy-page" @click.prevent="urlCopy">
          <span id="cAction"><font-awesome-icon :icon="['fas', 'link']" /></span>
        </button>
        <div id="snackbar">コピーしました</div>
      </div>
    </section>
    <div class="banner">
      <a href="https://haikata.l-ma.co.jp/">
        <img src="/img/about/haikata1.png" alt="ハイハイカタカタレース">
      </a>
    </div>
    <section class="recruiting-area">
      <div class="container">
        <h2>オンラインフェスタでは一緒に<br>盛り上げてくれる仲間を募集中</h2>
        <div class="row">
          <div class="box">
            <div class="inner">
              <a href="https://l-ma.info/2FR7TXw" target="_blank">
                <figure>
                  <img src="/img/about/recruiting_img01.jpg" alt="ママ主催者出演者募集">
                  <figcaption>ママ主催者出展者募集</figcaption>
                </figure>
              </a>
            </div>
            <div class="inner">
              <a href="https://corp.l-ma.co.jp/#contactfrom-section" target="_blank">
                <figure>
                  <img src="/img/about/recruiting_img02.jpg" alt="子育て応援企業出演社募集">
                  <figcaption>子育て応援企業出展社募集</figcaption>
                </figure>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="ig-follow">
      <a href="https://l-ma.info/2YHDMrf" target="_brank">
        <img src="/img/about/onfes_banner.png">
      </a>
      <!-- <div class="button">
        <a href="https://l-ma.info/2TioczM"
          target="_blank"><span>最新情報の<br>通知を受け取る</span></a>
      </div> -->
    </section>
  </main>
</template>

<script>
import WOW from 'wow.js'
import OnlineFestaSchedules from '@/components/templates/onlineFestaSchedules.vue'
import BannerAd from '@/components/BannerAd.vue'

export default {
  name: 'about',
  data: () => ({

  }),
  components: {
    OnlineFestaSchedules,
    BannerAd
  },
  methods: {
    urlCopy () {
      const selection = window.getSelection()
      const range = document.createRange()
      const el = document.createElement('pre')
      el.textContent = location.href
      document.body.appendChild(el)
      range.selectNodeContents(el)
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
      document.body.removeChild(el)
      var x = document.getElementById('snackbar')
      x.className = 'show'
      setTimeout(function () { x.className = x.className.replace('show', '') }, 2000)
    }
  },
  mounted () {
    new WOW().init()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kosugi+Maru&display=swap');
</style>

<style lang="scss" scoped>
html /deep/ {
  /* http://meyerweb.com/eric/tools/css/reset/
    v2.0 | 20110126
    License: none (public domain)
  */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
  /* Document
    ========================================================================== */
  /**
  * 1. Correct the line height in all browsers.
  * 2. Prevent adjustments of font size after orientation changes in iOS.
  */
  html {
    line-height: 1.15;
    /* 1 */
    -webkit-text-size-adjust: 100%;
    /* 2 */
  }

  /* Sections
      ========================================================================== */
  /**
    * Remove the margin in all browsers.
    */
  body {
    margin: 0;
  }

  /**
    * Render the `main` element consistently in IE.
    */
  main {
    display: block;
  }

  /**
    * Correct the font size and margin on `h1` elements within `section` and
    * `article` contexts in Chrome, Firefox, and Safari.
    */
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  /* Grouping content
      ========================================================================== */
  /**
    * 1. Add the correct box sizing in Firefox.
    * 2. Show the overflow in Edge and IE.
    */
  hr {
    -webkit-box-sizing: content-box;
            box-sizing: content-box;
    /* 1 */
    height: 0;
    /* 1 */
    overflow: visible;
    /* 2 */
  }

  /**
    * 1. Correct the inheritance and scaling of font size in all browsers.
    * 2. Correct the odd `em` font sizing in all browsers.
    */
  pre {
    font-family: monospace, monospace;
    /* 1 */
    font-size: 1em;
    /* 2 */
  }

  /* Text-level semantics
      ========================================================================== */
  /**
    * Remove the gray background on active links in IE 10.
    */
  a {
    background-color: transparent;
  }

  /**
    * 1. Remove the bottom border in Chrome 57-
    * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
    */
  abbr[title] {
    border-bottom: none;
    /* 1 */
    text-decoration: underline;
    /* 2 */
    -webkit-text-decoration: underline dotted;
            text-decoration: underline dotted;
    /* 2 */
  }

  /**
    * Add the correct font weight in Chrome, Edge, and Safari.
    */
  b,
  strong {
    font-weight: bolder;
  }

  /**
    * 1. Correct the inheritance and scaling of font size in all browsers.
    * 2. Correct the odd `em` font sizing in all browsers.
    */
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    /* 1 */
    font-size: 1em;
    /* 2 */
  }

  /**
    * Add the correct font size in all browsers.
    */
  small {
    font-size: 80%;
  }

  /**
    * Prevent `sub` and `sup` elements from affecting the line height in
    * all browsers.
    */
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /* Embedded content
      ========================================================================== */
  /**
    * Remove the border on images inside links in IE 10.
    */
  img {
    border-style: none;
  }

  /* Forms
      ========================================================================== */
  /**
    * 1. Change the font styles in all browsers.
    * 2. Remove the margin in Firefox and Safari.
    */
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    /* 1 */
    font-size: 100%;
    /* 1 */
    line-height: 1.15;
    /* 1 */
    margin: 0;
    /* 2 */
  }

  /**
    * Show the overflow in IE.
    * 1. Show the overflow in Edge.
    */
  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
    * Remove the inheritance of text transform in Edge, Firefox, and IE.
    * 1. Remove the inheritance of text transform in Firefox.
    */
  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
    * Correct the inability to style clickable types in iOS and Safari.
    */
  button,
  [type="button"],
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button;
  }

  /**
    * Remove the inner border and padding in Firefox.
    */
  button::-moz-focus-inner,
  [type="button"]::-moz-focus-inner,
  [type="reset"]::-moz-focus-inner,
  [type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
    * Restore the focus styles unset by the previous rule.
    */
  button:-moz-focusring,
  [type="button"]:-moz-focusring,
  [type="reset"]:-moz-focusring,
  [type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
    * Correct the padding in Firefox.
    */
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
    * 1. Correct the text wrapping in Edge and IE.
    * 2. Correct the color inheritance from `fieldset` elements in IE.
    * 3. Remove the padding so developers are not caught out when they zero out
    *    `fieldset` elements in all browsers.
    */
  legend {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    /* 1 */
    color: inherit;
    /* 2 */
    display: table;
    /* 1 */
    max-width: 100%;
    /* 1 */
    padding: 0;
    /* 3 */
    white-space: normal;
    /* 1 */
  }

  /**
    * Add the correct vertical alignment in Chrome, Firefox, and Opera.
    */
  progress {
    vertical-align: baseline;
  }

  /**
    * Remove the default vertical scrollbar in IE 10+.
    */
  textarea {
    overflow: auto;
  }

  /**
    * 1. Add the correct box sizing in IE 10.
    * 2. Remove the padding in IE 10.
    */
  [type="checkbox"],
  [type="radio"] {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    /* 1 */
    padding: 0;
    /* 2 */
  }

  /**
    * Correct the cursor style of increment and decrement buttons in Chrome.
    */
  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  /**
    * 1. Correct the odd appearance in Chrome and Safari.
    * 2. Correct the outline style in Safari.
    */
  [type="search"] {
    -webkit-appearance: textfield;
    /* 1 */
    outline-offset: -2px;
    /* 2 */
  }

  /**
    * Remove the inner padding in Chrome and Safari on macOS.
    */
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
    * 1. Correct the inability to style clickable types in iOS and Safari.
    * 2. Change font properties to `inherit` in Safari.
    */
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    /* 1 */
    font: inherit;
    /* 2 */
  }

  /* Interactive
      ========================================================================== */
  /*
    * Add the correct display in Edge, IE 10+, and Firefox.
    */
  details {
    display: block;
  }

  /*
    * Add the correct display in all browsers.
    */
  summary {
    display: list-item;
  }

  /* Misc
      ========================================================================== */
  /**
    * Add the correct display in IE 10+.
    */
  template {
    display: none;
  }

  /**
    * Add the correct display in IE 10.
    */
  [hidden] {
    display: none;
  }

  * {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
  }

  body {
    font-family: "Noto Sans JP", sans-serif;
    font-size: 1.6rem;
    line-height: 1.8;
    color: #333;
    position: relative;
    width: 100%;
    margin: 0;
  }

  section {
    margin-bottom: 5%;
    overflow: hidden;
  }

  .container {
    max-width: 850px;
    margin: 0 auto;
    padding: 0;
  }

  @media screen and (max-width: 900px) {
    .container {
      padding: 0 10px;
    }
  }

  .row {
    padding: 0;
    margin-bottom: 2em;
  }

  .row:last-child {
    margin-bottom: 0;
  }

  figure {
    text-align: center;
    margin: 0;
    line-height: 0;
  }

  img {
    max-width: 100%;
    vertical-align: middle;
    line-height: 1;
    border-style: none;
  }

  .time{
    color: #ed85a7;
    font-weight: normal;
    font-family: ff-market-web, sans-serif;
    font-size: 30px;
    line-height: 50px;
  }

  .box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
  }

  .box.reverse {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
        -ms-flex-direction: row-reverse;
            flex-direction: row-reverse;
  }

  .box .inner {
    width: 48%;
  }

  a {
    text-decoration: none;
    color: #ED84A5;
  }

  .text-center {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }

  h1 {
    font-size: 4rem;
  }

  h2 {
    font-size: 3.2rem;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 1.5em;
    text-align: center;
  }

  h3 {
    font-size: 3.2rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: .5em;
  }

  h4 {
    font-size: 2.4rem;
  }

  @media screen and (max-width: 767px) {
    h1 {
      font-size: 1.8rem;
    }
    h2 {
      font-size: 2rem;
    }
    h3 {
      font-size: 2rem;
    }
    h4 {
      font-size: 1.8rem;
    }
  }

  .main-visual {
    height: 0;
    padding-top: 58.19444%;
    background: url(/img/about/main_visual_bg.png) center top no-repeat;
    background-size: contain;
    position: relative;
    margin-bottom: 5%;
  }

  .main-visual .main-copy {
    position: absolute;
    top: 2%;
    bottom: auto;
    right: 50%;
    -webkit-transform: translateX(50%);
            transform: translateX(50%);
    width: 100%;
  }

  .main-visual .main-copy h1 {
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    line-height: 1.6;
  }

  .main-visual .main-copy h1 span {
    color: #FF4070;
    font-size: 4.8rem;
    line-height: 1.4;
  }

  .main-visual .main-copy h1 span span.date {
    font-size: 6.4rem;
  }

  .main-visual .main-copy p {
    font-size: 3.2rem;
    font-weight: bold;
    text-align: center;
    line-height: 1.4;
  }

  @media screen and (max-width: 1440px) {
    .main-visual .main-copy h1 {
      font-size: 2.8rem;
    }
    .main-visual .main-copy h1 span {
      font-size: 3rem;
    }
    .main-visual .main-copy h1 span span.date {
      font-size: 3.6rem;
    }
    .main-visual .main-copy p {
      font-size: 2rem;
    }
  }

  @media screen and (max-width: 1024px) {
    .main-visual .main-copy h1 {
      font-size: 2rem;
    }
    .main-visual .main-copy h1 span {
      font-size: 2.4rem;
    }
    .main-visual .main-copy h1 span span.date {
      font-size: 3rem;
    }
    .main-visual .main-copy p {
      font-size: 1.6rem;
    }
  }

  @media screen and (max-width: 767px) {
    .main-visual .main-copy h1 {
      font-size: 1.6rem;
    }
    .main-visual .main-copy h1 span {
      font-size: 2.2rem;
    }
    .main-visual .main-copy h1 span span.date {
      font-size: 2.4rem;
    }
    .main-visual .main-copy p {
      font-size: 1.4rem;
    }
  }

  .main-visual .main-copy.wow {
    opacity: 0;
    -webkit-transition: 3s;
    transition: 3s;
  }

  .main-visual .main-copy.wow.animated {
    opacity: 1;
    margin-top: 55px;
  }

  .youtube-area {
    margin-bottom: 0;
  }

  .youtube-area .movie {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    margin-bottom: 2em;
  }

  .youtube-area .movie iframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100% !important;
    height: 100% !important;
  }

  .youtube-area .share-btn {
    display: flex;
    align-items: center;
    padding: 5px 10px;
  }

  .share{
    text-align: center;
    font-size: 40px;
  }

  @media screen and (max-width: 767px){
    .share{
      text-align: center;
      font-size: 25px;
    }
  }

  .share-btn a{
    margin: 0 20px;
  }

  @media screen and (max-width: 767px){
    .share-btn a{
      margin: 0 10px;
    }
  }

  .share-btn svg {
    color: darkgray;
  }

  #copy-page{
    background-color: transparent;
    border: none;
    margin: 0 5px;
  }

  .step-area .step-detail {
    position: relative;
    z-index: 2;
    background: #fcf4f7;
    border-radius: 16px;
    max-width: 1280px;
    margin: 0 auto;
    padding: 3% 10px;
  }

  .step-area .step-detail p.step-txt {
    margin: 1em auto 1.5em;
  }

  .step-area .step-detail p.step-txt a {
    text-decoration: underline;
  }

  .step-area .step-detail .box {
    position: relative;
    padding-bottom: 2em;
  }

  .step-area .step-detail .box:not(:last-child):after {
    content: "";
    display: block;
    width: 60px;
    height: 60px;
    position: absolute;
    margin: auto;
    top: auto;
    bottom: -12px;
    right: 0;
    left: 0;
    z-index: -1;
    background: url(/img/about/border.svg) center no-repeat;
  }

  .step-area .step-detail .box:nth-child(even):after {
    -webkit-transform: rotateZ(90deg);
            transform: rotateZ(90deg);
  }

  .step-area .step-detail .box.wow .inner.txt {
    opacity: 0;
    -webkit-transform: translateY(50px);
            transform: translateY(50px);
    -webkit-transition: 1s .8s;
    transition: 1s .8s;
  }

  .step-area .step-detail .box.wow.animated .inner.txt {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .step-area .step-detail .box .inner.img {
    position: relative;
  }

  .step-area .step-detail .box .inner.img figure {
    overflow: hidden;
    border-radius: 16px;
    display: inline-block;
  }

  .step-area .step-detail .box .inner.img.step01:before {
    content: "";
    display: block;
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    top: -10px;
    bottom: auto;
    right: -10px;
    left: auto;
    z-index: 1;
    background: url(/img/about/step_ico01.png) center no-repeat;
  }

  .step-area .step-detail .box .inner.img.step01.wow:before {
    opacity: 0;
    -webkit-transform: scale(0.5) rotateZ(20deg);
            transform: scale(0.5) rotateZ(20deg);
    -webkit-transition: 1s;
    transition: 1s;
  }

  .step-area .step-detail .box .inner.img.step01.wow.animated:before {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .step-area .step-detail .box .inner.img.step02:before {
    content: "";
    display: block;
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    top: -10px;
    bottom: auto;
    right: -10px;
    left: auto;
    z-index: 1;
    background: url(/img/about/step_ico02.png) center no-repeat;
  }

  .step-area .step-detail .box .inner.img.step02.wow:before {
    opacity: 0;
    -webkit-transform: scale(0.5) rotateZ(20deg);
            transform: scale(0.5) rotateZ(20deg);
    -webkit-transition: 1s;
    transition: 1s;
  }

  .step-area .step-detail .box .inner.img.step02.wow.animated:before {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .step-area .step-detail .box .inner.img.step03:before {
    content: "";
    display: block;
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    top: -10px;
    bottom: auto;
    right: -10px;
    left: auto;
    z-index: 1;
    background: url(/img/about/step_ico03.png) center no-repeat;
  }

  .step-area .step-detail .box .inner.img.step03.wow:before {
    opacity: 0;
    -webkit-transform: scale(0.5) rotateZ(20deg);
            transform: scale(0.5) rotateZ(20deg);
    -webkit-transition: 1s;
    transition: 1s;
  }

  .step-area .step-detail .box .inner.img.step03.wow.animated:before {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .step-area .step-detail .box .inner.img.step04:before {
    content: "";
    display: block;
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    top: -10px;
    bottom: auto;
    right: -10px;
    left: auto;
    z-index: 1;
    background: url(/img/about/step_ico04.png) center no-repeat;
  }

  .step-area .step-detail .box .inner.img.step04.wow:before {
    opacity: 0;
    -webkit-transform: scale(0.5) rotateZ(20deg);
            transform: scale(0.5) rotateZ(20deg);
    -webkit-transition: 1s;
    transition: 1s;
  }

  .step-area .step-detail .box .inner.img.step04.wow.animated:before {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .step-area .step-detail .box .inner.img.step05:before {
    content: "";
    display: block;
    width: 80px;
    height: 80px;
    position: absolute;
    margin: auto;
    top: -10px;
    bottom: auto;
    right: -10px;
    left: auto;
    z-index: 1;
    background: url(/img/about/step_ico05.png) center no-repeat;
  }

  .step-area .step-detail .box .inner.img.step05.wow:before {
    opacity: 0;
    -webkit-transform: scale(0.5) rotateZ(20deg);
            transform: scale(0.5) rotateZ(20deg);
    -webkit-transition: 1s;
    transition: 1s;
  }

  .step-area .step-detail .box .inner.img.step05.wow.animated:before {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .step-area .step-detail .box .inner.txt h4 {
    font-weight: bold;
    line-height: 1;
    margin-bottom: .5em;
  }

  @media screen and (max-width: 1024px) {
    .step-area .step-detail .box .inner.txt h4 {
      line-height: 1.4;
    }
  }

  .award-area {
    background: #ED84A5;
    padding: 8% 5% 5%;
    margin: -10% 0 5%;
  }

  .award-area h2 {
    color: #fff;
  }

  .award-area .container {
    max-width: 840px;
  }

  .award-area .container .row:not(:last-child) {
    border-radius: 16px;
    overflow: hidden;
  }

  .award-area .container .row .box {
    background: #FCF4F7;
  }

  .award-area .container .row .box .inner {
    width: 50%;
  }

  .award-area .container .row .box .inner.txt p {
    font-size: 3.2rem;
    font-weight: bold;
    color: #ED84A5;
    text-align: center;
    line-height: 1.4;
  }

  .award-area .container .row .box.wow .inner.txt p {
    opacity: 0;
    -webkit-transform: rotateZ(20deg);
            transform: rotateZ(20deg);
    -webkit-transition: 1s;
    transition: 1s;
  }

  .award-area .container .row .box.wow.animated .inner.txt p {
    opacity: 1;
    -webkit-transform: none;
            transform: none;
  }

  .award-area .container .row p {
    font-size: 1.5rem;
    color: #fff;
  }

  .award-area .container .row p.btn {
    text-align: center;
    font-size: 2rem;
  }

  .award-area .container .row p.btn a {
    display: block;
    background: #fff;
    color: #ED84A5;
    font-weight: bold;
    padding: 15px;
    max-width: 400px;
    margin: 0 auto 1.5em;
    border-radius: 8px;
    -webkit-box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.2);
            box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.2);
    position: relative;
    -webkit-transition: .3s;
    transition: .3s;
  }

  .award-area .container .row p.btn a:after {
    content: "";
    display: block;
    width: 15px;
    height: 13px;
    position: absolute;
    margin: auto;
    top: 50%;
    bottom: auto;
    right: 4%;
    left: auto;
    -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
    z-index: 1;
    background: url(/img/about/arrow.svg) center no-repeat;
    -webkit-transition: .3s;
    transition: .3s;
  }

  .award-area .container .row p.btn a:hover {
    background: #FCF4F7;
  }

  .award-area .container .row p.btn a:hover:after {
    right: 3%;
  }

  .banner{
    width: 600px;
    margin: 0 auto;
  }

  .banner a img {
    margin-bottom: 2%;
  }

  .recruiting-area {
    margin-bottom: 10%;
  }

  .recruiting-area .container {
    max-width: 840px;
  }

  .recruiting-area .container .box .inner a {
    display: block;
    z-index: 0;
  }

  .recruiting-area .container .box .inner a figure {
    position: relative;
    display: inline-block;
    border-radius: 8px;
    overflow: hidden;
  }

  .recruiting-area .container .box .inner a figure img {
    -webkit-transition: .3s;
    transition: .3s;
  }

  .recruiting-area .container .box .inner a figure figcaption {
    position: absolute;
    top: 50%;
    right: 50%;
    -webkit-transform: translate(50%, 50%);
            transform: translate(50%, 50%);
    font-size: 2.4rem;
    font-weight: bold;
    color: #fff;
    width: 100%;
    z-index: 2;
  }

  .recruiting-area .container .box .inner a:hover figure img {
    -webkit-transform: scale(1.2);
            transform: scale(1.2);
  }

  .recruiting-area .container .box .inner:first-child a figure:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
    background: rgba(237, 132, 165, 0.6);
    -webkit-transition: .3s;
    transition: .3s;
  }

  .recruiting-area .container .box .inner:last-child a figure:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
    background: rgba(230, 166, 103, 0.8);
    -webkit-transition: .3s;
    transition: .3s;
  }

  .imgstep{
    width: 300px;
  }

  .ig-follow {
    margin-bottom: 0;
    position: fixed;
    right: 2%;
    bottom: 2%;
    z-index: 100;
    width: 337px;
    height: 141px;
    -webkit-box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.2);
            box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.2);
    // border-radius: 50%;
  }

  .ig-follow .button {
    display: block;
    height: 100%;
    background: #00AC3D;
    -webkit-transition: .5s;
    transition: .5s;
  }

  .ig-follow a {
    color: #fff;
    font-size: 1.6rem;
    font-weight: bold;
    line-height: 1.4;
    text-align: center;
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }

  .ig-follow a span {
    position: absolute;
    width: 100%;
    top: 50%;
    right: 50%;
    -webkit-transform: translate(50%, -50%);
            transform: translate(50%, -50%);
  }

  .ig-follow:hover .button {
    background: rgba(0, 172, 61, 0.8);
  }

  @media screen and (max-width: 900px) {
    .ig-follow {
      text-align: center;
      width: 230px;
      height: 105px;
    }
    .ig-follow a {
      font-size: 1.4rem;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 768px) {
    .tablet-only {
      display: none;
    }
  }

  @media screen and (min-width: 768px) {
    .sp-only {
      display: none;
    }
  }

  @media screen and (max-width: 767px) {
    .pc-only {
      display: none;
    }
    p {
      font-size: 1.4rem;
    }
  }

  @media screen and (max-width: 767px) and (max-width: 580px) {
    .main-visual {
      padding-top: 85.3333%;
      background: url(/img/about/sp_main_visual_bg.png) center top no-repeat;
      background-size: contain;
    }
  }

  @media screen and (max-width: 767px) {
    .step-area .step-detail .box {
      display: block;
    }
    .step-area .step-detail .box:not(:last-child):after {
      content: none;
    }
    .step-area .step-detail .box .inner {
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
    }
    .step-area .step-detail .box.wow .inner.txt {
      -webkit-transition: 1s .5s;
      transition: 1s .5s;
    }
    .award-area {
      padding: 8% 1% 5%;
    }
    .award-area .container .row {
      max-width: 337px;
      margin: 0 auto 2em;
    }
    .award-area .container .row .box .inner.txt p {
      font-size: 1.6rem;
    }
    .award-area .container .row p {
      font-size: 1.4rem;
    }
    .award-area .container .row p.btn {
      font-size: 1.6rem;
    }
    .recruiting-area {
      margin-bottom: 7em;
    }
    .recruiting-area .container .box {
      display: block;
    }
    .recruiting-area .container .box .inner {
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
    }
    .recruiting-area .container .box .inner a figure figcaption {
      font-size: 2rem;
    }
    .ig-follow {
      border-radius: 8px;
      right: 50%;
      -webkit-transform: translateX(50%);
              transform: translateX(50%);
      width: 337px;
      margin: 0 auto;
      height: 135px;
    }
    .ig-follow a {
      display: inline-block;
      // padding: 1em .4em;
    }
    .ig-follow a span {
      position: inherit;
      right: auto;
      top: auto;
      -webkit-transform: none;
              transform: none;
    }
    .ig-follow a span br {
      display: none;
    }
  }

  #snackbar {
    visibility: hidden;
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    font-size: 75%;
    padding: 20px 10px;
    color: #fff;
    background-color: #3FBD92;
  }

  #snackbar.show {
    visibility: visible;
  }

  @-webkit-keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }

  @keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
  }

  @-webkit-keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }

  @keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }

  .title-font {
    font-family: "Kosugi Maru";
  }

  #header {
    background: url(/img/about/bg_title_02.png) no-repeat 50% 100%, url(/img/about/bg_title_01.png) no-repeat 50% 0%;
    background-size: contain, cover;
    margin-bottom: 30px;
    padding: 25px 0 545px;
    text-align: center;
  }

  #header .title.title-font {
    color: white;
    font-size: 11vw;
    text-shadow: 0.02em 0.02em 0 #ffadc2, -0.02em -0.02em 0 #ffadc2, -0.02em 0.02em 0 #ffadc2, 0.02em -0.02em 0 #ffadc2, 0px 0.02em 0 #ffadc2, -0.02em 0 #ffadc2, -0.02em 0 0 #ffadc2, 0.02em 0 0 #ffadc2;
  }

  #header .title-sub {
    background: url(/img/about/bg_title-sub_01.png) no-repeat 0% 0%, url(/img/about/bg_title-sub_02.png) no-repeat 100% 0%;
    background-size: auto;
    display: inline-block;
    height: 195px;
    padding: 105px 90px 0 95px;
    margin-bottom: 15px;
  }

  #header .title-sub.title-font {
    color: white;
    font-size: 4vw;
    text-shadow: 0.02em 0.02em 0 #ffadc2, -0.02em -0.02em 0 #ffadc2, -0.02em 0.02em 0 #ffadc2, 0.02em -0.02em 0 #ffadc2, 0px 0.02em 0 #ffadc2, -0.02em 0 #ffadc2, -0.02em 0 0 #ffadc2, 0.02em 0 0 #ffadc2;
  }
  @media screen and (min-width: 1400px) {
    /* Header
    ---------------------------*/

    #header {
      background-size: contain, cover;
      padding: 25px 0 450px;
    }
  }
  @media screen and (min-width: 1400px) {
    /* Header
    ---------------------------*/

    #header {
      background-size: contain, cover;
      padding: 25px 0 450px;
    }
  }
  @media screen and (max-width: 1024px) {
    /* Header
    ---------------------------*/

    #header {
      background-size: contain, cover;
      padding: 25px 0 400px;
    }
  }
  @media screen and (max-width: 768px) {
    /* Header
    ---------------------------*/

    #header {
      padding: 25px 30px 320px;
      background-size: contain, cover;
    }
  }
  #header {
    padding: 15px 15px 140px;
    background-size: contain, cover;
  }

  #header .title-sub {
    background-size: 33px 76px, 27px 62px;
    margin-bottom: 10px;
    padding: 15px 40px 0;
    height: 80px;
  }

  #header .title-sub.title-font {
    background-size: contain;
    margin-bottom: 10px;
    padding: 15px 34px 0;
    height: 48px;
    color: white;
    font-size: 20px;
    text-shadow: 1px 1px 0 #ffadc2, -1px -1px 0 #ffadc2, -1px 1px 0 #ffadc2, 1px -1px 0 #ffadc2, 0px 1px 0 #ffadc2, -1px 0 #ffadc2, -1px 0 0 #ffadc2, 1px 0 0 #ffadc2;
  }
  @media screen and (min-width: 1024px) {
    #header .title-sub.title-font {
    padding: 105px 95px 0 95px;
    height: 195px;
    font-size: 4vw;
    }
  }
  @media screen and (min-width: 768px) {
    #header .title-sub.title-font {
    padding: 70px 95px 0 95px;
    height: 140px;
    font-size: 4vw;
    }
  }

  #header .title {
    width: 75%;
    margin: 0 auto;
  }
  .container {
    width: 940px;
    margin: 0 auto;
    padding: 70px 0 100px;
  }

  .tab-menu {
    display: flex;
    justify-content: space-between;
    margin: 0 -6px;
  }

  .tab-menu li {
    flex-grow: 1;
    padding: 0 6px;
  }

  .tab-menu li.active span,
  .tab-menu li:hover span {
    background: #9E8375;
    color: #FFFFFF;
    font-weight: bold;
  }

  .tab-menu li span {
    display: block;
    background: #FFFFFF;
    color: #9E8375;
    border: 2px solid #9E8375;
    border-bottom: none;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    height: 56px;
    line-height: 56px;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }

  .tab-content-wrap {
    border-top: 2px solid #9E8375;
    padding-top: 25px;
  }

  .tab-content {
    display: none;
  }

  .tab-content.active {
    display: block;
  }

  .area-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -20px;
  }

  .area-list li {
    width: 33.3333%;
    padding: 0 20px;
    margin-bottom: 20px;
  }

  .area-list li .clm {
    background: #FFFFFF;
    border-radius: 5px;
    padding: 20px;
    text-align: center;
    position: relative;
  }

  .area-list li .clm:before {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 22px 22px 0 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .area-list li .clm .clm-title {
    color: #6c5a50;
    border-bottom: 1px dashed #d8d8d8;
    padding-bottom: 15px;
    margin-bottom: 15px;
    font-size: 20px;
  }

  .area-list li .clm .date {
    color: #6c5a50;
    margin-bottom: 10px;
    word-break: break-all;
    font-size: 14px;
    font-weight: bold;
  }

  .area-list li .clm .date strong {
    font-size: 29px;
  }

  .area-list li .clm .place {
    line-height: 1.4;
  }

  .area-list li.kanto .clm {
    border: 2px solid #FFA3B4;
  }

  .area-list li.kanto .clm:before {
    border-color: #FFA3B4 transparent transparent transparent;
  }

  .area-list li.kanto .comingsoon::after {
    background-color: #FFA3B4;
  }

  .area-list li.chubu .clm {
    border: 2px solid #67C9F7;
  }

  .area-list li.chubu .clm:before {
    border-color: #67C9F7 transparent transparent transparent;
  }

  .area-list li.chubu .comingsoon::after {
    background-color: #67C9F7;
  }

  .area-list li.kansai .clm {
    border: 2px solid #E6CF24;
  }

  .area-list li.kansai .clm:before {
    border-color: #E6CF24 transparent transparent transparent;
  }

  .area-list li.kansai .comingsoon::after {
    background-color: #E6CF24;
  }

  .area-list li.kyusyu .clm {
    border: 2px solid #5FC982;
  }

  .area-list li.kyusyu .clm:before {
    border-color: #5FC982 transparent transparent transparent;
  }

  .area-list li.kyusyu .comingsoon::after {
    background-color: #5FC982;
  }

  .area-list li.hokkaido .clm {
    border: 2px solid #FFBF7F;
  }

  .area-list li.hokkaido .clm:before {
    border-color: #FFBF7F transparent transparent transparent;
  }

  .area-list li.hokkaido .comingsoon::after {
    background-color: #FFBF7F;
  }

  .area-list li a.comingsoon:after {
    padding: 8px 0;
  }

  .area-list li a.comingsoon .clm .clm-heading .clm-title {
    padding-top: 30px;
    font-size: 16px;
  }
  #event-area .sec-title > .title .sub {
    position: absolute;
    top: -70px;
    left: -80px;
    z-index: 0;
  }

  #event-area .sec-title > .title:after {
    background: url("/images/home/bg_tit_01.png") no-repeat 100% 0%;
    width: 32px;
    height: 33px;
    top: -25px;
    right: -25px;
  }

  #event-area .sec-title > .title .sub {
    width: 50px;
    top: -35px;
    left: -25px;
  }

  #event-area .sec-title > .title .sub img {
    height: auto;
  }

  /*==============================================

    SP

  ================================================*/

  @media screen and (min-width: 1400px) {
    /* Header
    ---------------------------*/

    #header {
      background-size: contain, cover;
      padding: 25px 0 450px;
    }
  }

  @media screen and (max-width: 1024px) {
    /* Header
    ---------------------------*/

    #header {
      background-size: contain, cover;
      padding: 25px 0 400px;
    }
  }

  @media screen and (max-width: 940px) {
    /* Common
    ---------------------------*/

    .container {
      width: 100%;
      padding: 50px 30px 80px;
    }

    .tab-menu li span {
      font-size: 26px;
    }

    .area-list li {
      padding: 0 10px;
    }

    .area-list li .clm .date strong {
      font-size: 24px;
    }
  }

  @media screen and (max-width: 768px) {
    /* Header
    ---------------------------*/

    #header {
      padding: 25px 30px 320px;
      background-size: contain, cover;
    }

    /* Common
    ---------------------------*/

    .tab-menu li span {
      font-size: 22px;
    }

    .area-list {
      margin: 0 -8px;
    }

    .area-list li {
      padding: 0 8px;
    }

    .area-list li .clm {
      padding: 15px;
    }

    .area-list li .clm .place {
      font-size: 14px;
    }

    /* About area
    ---------------------------*/

    #about-area .container {
      width: 100%;
    }

    /* Voice area
    ---------------------------*/

    #voice-area .voice-list {
      margin: 0 -20px;
    }

    #voice-area .voice-list li {
      padding: 0 20px;
    }

    .area-list li a.comingsoon:after {
      padding: 6px 0;
      font-size: 16px;
    }

    .area-list li a.comingsoon .clm .clm-heading .clm-title {
      padding-top: 20px;
      font-size: 16px;
    }

    #corp-banner .flex {
      display: block;
    }

    #corp-banner a {
      display: block;
    }

    #corp-banner a:first-child {
      margin: 0 0 10px;
    }

    #corp-banner a:last-child {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 630px) {
    .tab-menu {
      margin: 0 -3px;
    }

    .tab-menu li {
      padding: 0 3px;
    }

    .tab-menu li span {
      font-size: 17px;
    }
  }

  @media screen and (max-width: 480px) {
    /* Common
    ---------------------------*/

    .container {
      padding: 30px 15px 50px;
    }

    .sec-title {
      background-size: 150% 18px;
      padding: 0 30px 10px;
    }

    .sec-title > .title img {
      height: 30px;
    }

    .tab-menu {
      margin: 0 -2px;
    }

    .tab-menu li {
      padding: 0 2px;
    }

    .tab-menu li span {
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }

    .area-list {
      margin: 0 -5px;
    }

    .area-list li {
      width: 50%;
      margin-bottom: 10px;
      padding: 0 5px;
    }

    .area-list li .clm {
      padding: 15px 10px;
    }

    .area-list li .clm .clm-title {
      padding-bottom: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    }

    .area-list li .clm .date {
      font-size: 10px;
    }

    .area-list li .clm .date strong {
      font-size: 16px;
    }

    .area-list li .clm .place {
      font-size: 12px;
    }

    .area-list li a.comingsoon:after {
      padding: 4px 0;
      font-size: 12px;
    }

    .area-list li a.comingsoon .clm .clm-heading .clm-title {
      padding-top: 10px;
      font-size: 14px;
    }

    /* Header
    ---------------------------*/

    #header {
      padding: 15px 15px 140px;
      background-size: contain, cover;
    }

    #header .title-sub {
      background-size: 33px 76px, 27px 62px;
      margin-bottom: 10px;
      padding: 15px 40px 0;
      height: 80px;
    }

    #header .title-sub.title-font {
      background-size: contain;
      margin-bottom: 10px;
      padding: 15px 34px 0;
      height: 48px;
      color: white;
      font-size: 20px;
      text-shadow: 1px 1px 0 #ffadc2, -1px -1px 0 #ffadc2, -1px 1px 0 #ffadc2, 1px -1px 0 #ffadc2, 0px 1px 0 #ffadc2, -1px 0 #ffadc2, -1px 0 0 #ffadc2, 1px 0 0 #ffadc2;
    }
    @media screen and (min-width: 1024px) {
      #header .title-sub.title-font {
      padding: 105px 95px 0 95px;
      height: 195px;
      font-size: 4vw;
      }
    }
    @media screen and (min-width: 768px) {
      #header .title-sub.title-font {
      padding: 70px 95px 0 95px;
      height: 140px;
      font-size: 4vw;
      }
    }
    #header .title {
      width: 75%;
      margin: 0 auto;
    }

    /* Event area
    ---------------------------*/

    #event-area .sec-title > .title .sub {
      width: 50px;
      top: -35px;
      left: -25px;
    }

    #event-area .sec-title > .title .sub img {
      height: auto;
    }

    /* About area
    ---------------------------*/

    #about-area .sec-title > .title:after {
      top: -45px;
      left: -25px;
    }

    #about-area .movie-clm {
      margin-bottom: 30px;
    }

    #about-area .movie-clm iframe {
      height: 180px;
    }

    #about-area .txt {
      font-size: 14px;
    }

    /* Contents area
    ---------------------------*/

    #contents-area .contents-list li {
      width: 50%;
    }

    /* Voice area
    ---------------------------*/

    #voice-area .sec-title > .title:after {
      top: -30px;
      left: -55px;
    }

    #voice-area .voice-list {
      flex-wrap: wrap;
    }

    #voice-area .voice-list li {
      width: 100%;
      margin-bottom: 50px;
      margin-top: 0 !important;
    }

    #voice-area .voice-list .name {
      margin-bottom: 20px;
      padding-bottom: 20px;
    }

    /* Report area
    ---------------------------*/

    #report-area .sec-title > .title:after {
      top: -50px;
      left: -60px;
    }

    #report-area .report-wrap {
      flex-wrap: wrap;
    }

    #report-area .report-list {
      width: 100%;
      padding: 0 15px;
    }

    #report-area .report-list dt {
      font-size: 14px;
    }

    #report-area .report-list dt .tag {
      font-size: 12px;
    }

    #report-area .report-list dd {
      font-size: 16px;
    }

    /* Join area
    ---------------------------*/

    #join-area .sec-title > .title:after {
      top: -35px;
      left: -20px;
    }

    #join-area .sub-title {
      margin-bottom: 20px;
      font-size: 20px;
    }

    .btn-store {
      margin-top: 30px;
    }

    .btn-store a {
      height: auto;
      line-height: 1.3;
      padding: 10px;
      font-size: 16px;
    }

    /* Footer
    ---------------------------*/

    #footer .footer-nav {
      display: block;
      text-align: center;
    }

    #footer .footer-nav li {
      margin-bottom: 10px;
      border-right: none;
    }

    .banner{
      width: 100%;
    }
  }

  @media screen and (max-width: 350px) {
    .tab-menu li span {
      font-size: 10px;
    }
  }
}

@import "/css/animate.css";
</style>
